import React from 'react';
import {
  Flex,
  Heading,
  Text,
  Box,
  Image,
  Tag,
  useColorMode,
  PseudoBox,
  Stack,
  Grid,
} from '@chakra-ui/core';
import { Link, StaticQuery, graphql } from 'gatsby';
import Img, { FluidObject } from 'gatsby-image';
import { kebabCase } from 'lodash';

interface Props {
  title: string;
  date: string;
  tags: string[];
  description: string;
  staticImage?: FluidObject;
  slug: string;
}

const BlogPostListItem = ({
  title,
  date,
  tags,
  description,
  staticImage,
  slug,
}: Props) => {
  const { colorMode } = useColorMode();

  return (
    <Box
      background='#ffffff'
      borderRadius={4}
      mb={4}
      boxShadow='0px 3px 6px 0px rgba(0, 0, 0, 0.18)'
    >
      <Flex
        align='stretch'
        justify='stretch'
        direction={['column', 'column', 'row', 'row']}
      >
        {staticImage ? (
          <Link to={slug}>
            <Flex
              position='relative'
              width={['100%', '100%', 56, 64]}
              height='100%'
              align='center'
              justify='center'
              flexShrink={0}
            >
              <PseudoBox
                position='absolute'
                top={0}
                left={0}
                bg='rgba(50, 150, 150, 0.6)'
                opacity={0}
                _hover={{
                  opacity: 1,
                }}
                height='100%'
                width='100%'
                zIndex={2}
                transition='0.2s all'
                display='flex'
                alignItems='center'
                justifyContent='center'
              >
                <Heading size='md' color='#ffffff'>
                  Read →
                </Heading>
              </PseudoBox>
              <Img
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  overflow: 'hidden',
                  minWidth: '100%',
                  minHeight: '100%',
                  zIndex: 0,
                }}
                imgStyle={{
                  flexShrink: 0,
                  minWidth: '100%',
                  minHeight: '100%',
                }}
                fluid={staticImage}
                draggable={false}
              />
            </Flex>
          </Link>
        ) : (
          <></>
        )}
        <Stack flex={1} p={4}>
          <Text color={colorMode === 'light' ? '#344159' : '#BDBFBF'}>
            {date}
          </Text>
          <Link to={slug}>
            <Heading size='md' flex={1}>
              {title}
            </Heading>
          </Link>
          <Text>{description}</Text>
          <Box mt={[1, 1, 0, 0]}>
            {tags.map((tag, index) => (
              <Link key={index} to={`/tags/${kebabCase(tag)}/`}>
                <PseudoBox
                  as={Tag}
                  _hover={{
                    background: '#E1E6EB',
                    color: '#0E1219',
                  }}
                  ml={index !== 0 ? 2 : 0}
                  mt={2}
                >
                  {tag}
                </PseudoBox>
              </Link>
            ))}
          </Box>
        </Stack>
      </Flex>
    </Box>
  );
};

export default BlogPostListItem;
